export const rulesLookupFieldDropdown =  [
	{
	  title: "By Rule Number",
	  value: "ruleNum"
	},
	{
	  title: "By Rule Description",
	  value: "ruleDesc"
	},
	{
	  title: "By Rule Attribute Value",
	  value: "ruleAttrVal"
	},
	{
	  title: "By Rule Output Value",
	  value: "ruleOutVal"
	}
];



// WEBPACK FOOTER //
// ./src/pages/returnDispositionRules/filter/rulesLookupFieldDropdown.js